// isVisible is checked live on every render, not just once, so the caller can pass a
// function like () => this.reportType === "patientReport" and have this panel react to
// changes. The statusBar object given to the grid must stay the same object for its whole
// life though. If we swap it for a new one after mount and ag-grid-vue3 rebuilds the entire
// status bar, it will forget the custom components we registered.

export default {
  template: `
    <div v-show="isVisible" class="ag-paging-panel">
      <m-link class="ag-paging-description" @click="onClick">Patient not included?</m-link>
    </div>
  `,
  computed: {
    isVisible() {
      return this.params.isVisible ? this.params.isVisible() : true;
    },
  },
  methods: {
    async onClick() {
      const patientId = await this.$patientSearch();
      if (patientId) {
        this.params.onPatientNotIncluded?.(patientId);
      }
    },
  },
};
